import {
  CreateContextProvider,
  SaveButton,
  SimpleForm,
  TextInput,
  Title,
  useCreateController,
} from "react-admin";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";

export const UserCategoryCreate = (props: any) => {
  const controller: any = useCreateController({
    resource: "user-categories/crud",
  });
  return (
    <CreateContextProvider value={controller}>
      <Title title="Categorias de Sócios" />
      {/* toolbar={false}: Salvar no topo, na linha do breadcrumb */}
      <SimpleForm toolbar={false}>
        <PageTopBreadcrumb
          title="Categoria de Sócios"
          firstPath="/#/user-categories/crud"
          secondTitle="Novo"
          actions={<SaveButton label="Salvar" />}
        />
        <Card sx={{ padding: 2, marginBottom: 3, width: "100%" }}>
          <CardHeader
            title="Criar Novo"
            // subheader="September 14, 2016"
          />
          <CardContent>
            <Grid container spacing={0.5}>
              <Grid item xs={12} lg={12}>
                <TextInput
                  source="name"
                  label="Nome"
                  fullWidth
                  helperText={false}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </SimpleForm>
    </CreateContextProvider>
  );
};
